import { variable } from './tools/variable';
import { html } from './tools/html';

import navigation, { TParameters } from'../../../pip/library/pi-navigation/pi-navigation.js';
import $ip from'../../../pip/library/pi-ip/pi-ip.js';

type TConstants = Record<string, unknown>;

/**
 * to keep values safe we support two features:
 *
 * 1. clean special types of data (Eg. uri)
 * 2. support a constant database so we can keep values hidden in closures and reference them in code
 *
 * @deprecated every method is deprecated
 */
class Safe {
  /**
   * include more constants to the existing database
   * @deprecated use $ip.constants.upgrade
   */
  appendConstants(constants: TConstants = {}) {
    return $ip.constants.upgrade(constants);
  }

  /**
   * clear the constants with a new set
   * @deprecated use $ip.constants.replace
   */
  overrideConstants(constants: TConstants = {}) {
    return $ip.constants.replace(constants);
  }

  /**
   * safe variable in a configuration
   * @param _variable
   * @param constants
   * @deprecated never used
   */
  variable(_variable: string, constants?: TConstants) {
    return variable($ip.constants.read(_variable, constants));
  }

  /**
   * safe HTML against XSS
   * @param _string
   * @param constants
   * @deprecated use lit-html#unsafeHTML
   */
  html(_string: string, constants?: TConstants) {
    return html($ip.constants.read(_string, constants));
  }

  /**
   * serialize or deserialize based on the parameters
   * @deprecated navigation.uri.parameters
   */
  parameters(parameters: TParameters | string, constants?: TConstants) {
    return navigation.uri.parameters(parameters, constants);
  }

  /**
   * return the base of the uri, without parameters
   *
   * @param uri the uri to collect parameters from
   * @deprecated use navigation.uri.readBase
   */
  uriBase(uri: string): string {
    return navigation.uri.readBase(uri);
  }

  /**
   * convert a uri with key/value pairs after `?` in to a dictionary of strings
   *
   * @param uri the uri to collect parameters from
   * @deprecated use navigation.uri.readParameters
   */
  uriParameters(uri: string) {
    return navigation.uri.readParameters(uri);
  }

  /**
   * convert a key/value pairs to a dictionary of strings
   *
   * @param uri the uri to collect parameters from
   * @deprecated use navigation.uri.deserializeParameters
   */
  deserializeParameters(uri: string) {
    return navigation.uri.deserializeParameters(uri);
  }

  /**
   * convert parameters to a safe uri string (append to a uri after `?`)
   *
   * @param parameters a dictionary of keys
   * @param constants additional lookup values for any values in the parameters
   * @deprecated use navigation.uri.serializeParameters
   */
  serializeParameters(parameters: TParameters, constants?: TConstants) {
    return navigation.uri.serializeParameters(parameters, constants);
  }

  /**
   * build a string of uri to a single safe uri
   * @deprecated use navigation.uri.concatenate
   */
  concatenateURI(uris: string[]): string {
    return navigation.uri.concatenate(uris);
  }

  /**
   * safe URI against
   * @param _uri
   * @param constants
   * @deprecated use navigation.uri.write
   */
  uri(_uri: string, constants?: TConstants, params?: TParameters) {
    return navigation.uri.write(this.variable(_uri, constants), params);
  }
}

const safe = new Safe();
export default safe;
